import React, { useEffect, useState } from 'react';
import { Badge, Table } from 'reactstrap';
import { getWorkshopItemsByChassis, openWorkshopFile } from '../../atolye/api';

// Şase Sorgulama > Atölye: read-only history of this VIN's workshop (repair) items, open and fixed — a purely
// additive enrichment layer next to the Tarihçe (movement) and Devir-Teslim (custody) tabs. Never touches, and is
// never derived from live-editing, the custody record itself — see db-migrations/054_workshop_module.sql.
const AtolyeTab = ({ chassisNo }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (!chassisNo) return setItems([]);
        getWorkshopItemsByChassis(chassisNo).then(setItems).catch(() => setItems([]));
    }, [chassisNo]);

    if (items.length === 0) {
        return <div className="text-muted p-2">Bu araç için atölye kaydı yok.</div>;
    }

    return (
        <Table responsive size="sm" className="mt-2">
            <thead>
                <tr>
                    <th>Tarih</th><th>Kaynak</th><th>Bölge</th><th>Parça</th><th>Hasar</th><th>Not</th><th>Durum</th><th>Ekleyen / Tamamlayan</th><th>Dosyalar</th>
                </tr>
            </thead>
            <tbody>
                {items.map((it) => (
                    <tr key={it.id}>
                        <td>{new Date(it.created_at).toLocaleString('tr-TR')}</td>
                        <td>{it.source === 'CUSTODY' ? `Devir-teslim${it.ref_handover_no ? ` (${it.ref_handover_no})` : ''}` : 'Elle eklendi'}</td>
                        <td>{it.zone_name}</td>
                        <td>{it.component_name}</td>
                        <td>{it.damage_name}</td>
                        <td>{it.note}{it.fix_note && <div className="text-success small">Onarım: {it.fix_note}</div>}</td>
                        <td><Badge color={it.status === 'TAMAMLANDI' ? 'success' : 'warning'}>{it.status === 'TAMAMLANDI' ? 'tamamlandı' : 'açık'}</Badge></td>
                        <td>{it.created_by_name}{it.fixed_by_name ? ` → ${it.fixed_by_name}` : ''}</td>
                        <td>
                            {(it.files || []).map((f) => (
                                <div key={f.id}>
                                    <button type="button" className="btn btn-link p-0" onClick={() => openWorkshopFile(f.path)}>
                                        {f.kind === 'PHOTO' ? '📷' : '📄'} {f.filename}
                                    </button>
                                </div>
                            ))}
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default AtolyeTab;
